// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/css/myp-sidebar-tabs.css
// module id = AFZU
// module chunks = 1